import AhoyTracker from 'shared/ahoy_tracker';

export default class MobileScheduleTabs {
  constructor(element) {
    this.element = element;
    this.dataTarget = this.element.getAttribute('data-tab-target');
    this.tabContents = document.querySelectorAll(this.dataTarget);
    let dateEl = document.querySelector('.b-livestreaming-daily-schedule__date-container');
    this.ahoy = new AhoyTracker(dateEl);
  }

  init() {
    this.bindClick();
  }

  bindClick() {
    this.element.addEventListener('focus', () => {
      this.ahoy.sendEvent();
    });

    this.element.addEventListener('change', (e) => {
      this.removeAllTabActive();
      document.querySelector(e.target.value).classList.add('tab-active');
    });
  }

  removeAllTabActive() {
    for(let idx = 0; idx < this.tabContents.length; idx++) {
      this.tabContents[idx].classList.remove('tab-active');
    }
  }
}
